import {isFeatureEnabled} from 'feature-flags';

import {FieldValues} from 'react-hook-form';

import {featureFlags} from '@dms/feature-flags';

import {FeaturesPickerProps} from '../types/FeaturesPickerProps';
import {FeaturesPickerFlat} from './FeaturesPickerFlat';
import {FeaturesPickerWithSubCategories} from './FeaturesPickerWithSubCategories';

export function FeaturesPicker<TFieldValues extends FieldValues = FieldValues>(
  props: FeaturesPickerProps<TFieldValues>
) {
  return isFeatureEnabled(featureFlags.SALES_FEATURE_SUBCATEGORIES) ? (
    <FeaturesPickerWithSubCategories {...props} />
  ) : (
    <FeaturesPickerFlat {...props} />
  );
}
